<template>
  <v-card
    class="main-thread"
    tile
    elevation="2"
    id="main-thread"
    :style="color"
    :class="{ 'main-thread--certible': tenant === 'certible' }"
  >
    <v-row no-gutters class="main-container">
      <v-col cols="4" class="steps-sidebar d-none d-md-flex flex-column"> </v-col>
      <v-col cols="12" md="8" class="wrapper">
        <!-- Step 6 -->
        <div class="step--mobile d-flex d-md-none"></div>
        <div class="content--mobile">
          <v-container class="payment-container d-flex flex-column justify-center">
            <div class="text-center">
              <v-progress-circular
                :size="50"
                :width="7"
                :color="uiColor"
                indeterminate
                v-if="!paymentSuccessful && !paymentFailed"
                :aria-label="$t('loading')"
                :aria-busy="!paymentSuccessful && !paymentFailed"
                aria-live="polite"
              ></v-progress-circular>
            </div>
            <!-- PAYMENT SUCCESS -->
            <div v-if="paymentSuccessful" class="text-center">
              <v-icon color="#c8e6c9" size="100"> $vuetify.icons.checkboxMarkedCircle </v-icon>
              <div class="text-checkout-sum mt-3">
                {{ $t("payment_successful_1") }}
              </div>
              <div class="text-checkout-details mt-2">
                {{ $t("payment_successful_2") }}
              </div>
            </div>
            <!-- PAYMENT FAILED -->
            <div v-if="paymentFailed" class="text-center">
              <v-icon color="#f0404f" size="100"> $vuetify.icons.closeCircle </v-icon>
              <div class="text-checkout-sum mt-3">
                {{ $t("payment_failed") }}
              </div>
            </div>
          </v-container>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { PROVIDER_CONFIG } from "../config/provider.config";

export default {
  name: "PaymentReturn",
  mounted() {
    var self = this;
    self.includeStripe(
      "js.stripe.com/v3/",
      function () {
        if (typeof window !== "undefined") {
          const provider = this.$route.params.provider;
          var stripe = window.Stripe(PROVIDER_CONFIG[this.$store.getters["registration/env"].stage][provider].stripePk);
          let urlParams = new URLSearchParams("?" + window.location.href.split("?")[1]);
          let clientSecret = urlParams.get("payment_intent_client_secret");
          if (clientSecret) {
            stripe.retrievePaymentIntent(clientSecret).then(function (response) {
              console.log(response);
              if (response.error) {
                self.paymentFailed = true;
              } else if (response.paymentIntent && response.paymentIntent.status === "succeeded") {
                self.paymentSuccessful = true;
              } else {
                self.paymentFailed = true;
              }
            });
          }
        }
      }.bind(self)
    );
  },
  data() {
    return {
      paymentSuccessful: false,
      paymentFailed: false,
      uiColor: this.$store.getters["registration/uiColor"],
    };
  },
  methods: {
    includeStripe(URL, callback) {
      let documentTag = document,
        tag = "script",
        object = documentTag.createElement(tag),
        scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = "https://" + URL;
      if (callback) {
        object.addEventListener(
          "load",
          function (e) {
            callback(null, e);
          },
          false
        );
      }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
  },
  computed: {
    color() {
      return {
        "--var-ui-color": this.$store.getters["registration/uiColor"],
      };
    },
    tenant() {
      return this.$store.getters["registration/tenant"];
    },
  },
};
</script>

<style scoped>
.main-thread--certible {
  margin-top: 1rem !important;
  margin-bottom: 30rem !important;
}
.main-thread {
  max-width: 1000px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 10px;
  min-height: 500px;
  display: flex;
}
.steps-sidebar {
  background-color: var(--var-ui-color);
}
.steps-container {
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  margin-top: 50px;
  margin-bottom: 50px;
}
.steps-green-text {
  color: var(--var-ui-color);
  font-weight: 800;
  font-size: 14pt;
}
.steps-white-text {
  color: white;
  font-weight: 500;
  font-size: 12pt;
}
.step-element {
  opacity: 0.3;
}
.step-element:active {
  opacity: 1;
}
.wrapper {
  position: relative;
}

.step--mobile {
  background-color: var(--var-ui-color);
  margin-left: 0;
  margin-right: 0;
  height: 64px;
  display: flex;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}
.payment-container {
  height: 100%;
}
@media (max-width: 960px) {
  .main-thread--certible {
    margin-top: 0rem !important;
  }
  .payment-container {
    height: fit-content !important;
  }
  .content--mobile {
    height: fit-content !important;
    margin-left: 0;
    margin-right: 0;
    display: flex;
    align-items: center;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
      0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  }
  .main-thread {
    min-height: fit-content;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.2s;
    overflow: hidden;
  }
  .fade-enter,
  .fade-leave-to {
    height: 0;
    opacity: 0;
  }
}
.content--mobile {
  height: 100%;
}
.exam-logo {
  width: 70px;
  margin-right: 12px;
}
.vertical-center {
  vertical-align: middle;
}
.summary--mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  overflow: hidden;
  height: 64px;
  background-color: #a78682;
  width: 100%;
  box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.25);
}
.summary-text--mobile {
  line-height: 64px;
  vertical-align: middle;
}
</style>
